export const GET_ALL_CLIENT = `GET_ALL_CLIENT`;
export const SET_CLIENTS = `SET_CLIENTS`;
export const UPDATE_CLIENT = `UPDATE_CLIENT`;

export const GET_ALL_VENDOR = `GET_ALL_VENDOR`;
export const SET_VENDORS = `SET_VENDORS`;
export const UPDATE_VENDOR = `UPDATE_VENDOR`;